import { IExportDeclarationTaskPersistence, IExportDeclarationTask } from '../interfaces';

export class ExportDeclarationTaskMapper {
  public static toDomain(task: IExportDeclarationTaskPersistence): IExportDeclarationTask {
    return {
      id: task.id,
      type: task.type,
      filePath: task.file_path,
      createdAt: task.created_at,
      updatedAt: task.updated_at,
      user: {
        id: task.user?.id ?? task.user_id,
        name: task.user.user_name,
      },
      status: {
        id: task.status.id,
        name: task.status.name,
      },
      model: {
        id: task.model.id ?? task.model_id,
        name: task.model.name,
      },
    };
  }
}
